import { reducer } from 'rxbeach';
import { CrudActions, EntityTypeItem } from './types';

export type CrudState<EntityType extends EntityTypeItem> = {
  byId: Record<string, EntityType>;
};

export const defaultState = {
  byId: {},
};

export const crudReducers = <Request, EntityType extends EntityTypeItem>(
  actions: CrudActions<Request, EntityType>
) => [
  reducer(
    [actions.setItems, actions.create, actions.put, actions.apiPut],
    (state: CrudState<EntityType>, items) => ({
      ...state,
      byId: items.reduce(
        (acc, item) => ({ ...acc, [item.id]: item }),
        state.byId
      ),
    })
  ),
  reducer(
    [actions.apiDelete, actions.remove],
    (state: CrudState<EntityType>, ids) => ({
      ...state,
      byId: ids.reduce((acc, id) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [id]: _, ...rest } = acc;
        return rest;
      }, state.byId),
    })
  ),
];
